<template>
  <div class="app-navbar-actions">
    <!-- <NotificationDropdown class="app-navbar-actions__item" /> -->
    <va-switch v-model="iAmOnline" size="small" true-label="Online" false-label="Offline" />

    <profile-dropdown class="app-navbar-actions__item app-navbar-actions__item--profile mr-1" />
    <coexistence-sync-progress />
  </div>
</template>

<script lang="ts" setup>
import { VaSwitch } from 'vuestic-ui/web-components'
import ProfileDropdown from './dropdowns/ProfileDropdown.vue'
import CoexistenceSyncProgress from '@/components/settings/CoexistenceSyncProgress.vue'
import { ref, watch } from 'vue'
import { authStore } from '../../../stores/auth'

// import NotificationDropdown from './dropdowns/NotificationDropdown.vue'

defineProps({
  isMobile: { type: Boolean, default: false },
})

const iAmOnline = localStorage.getItem('online') === 'true' ? ref(true) : ref(false)

const auth = authStore()

watch(iAmOnline, (teste) => {
  auth.changeUserStatus()
})
</script>

<style lang="scss">
.app-navbar-actions {
  display: flex;
  align-items: center;

  .va-dropdown__anchor {
    color: var(--va-primary);
    fill: var(--va-primary);
  }

  &__item {
    padding: 0;
    margin-left: 0.25rem;
    margin-right: 0.25rem;

    svg {
      height: 20px;
    }

    &--profile {
      display: flex;
      justify-content: center;
    }

    .va-dropdown-content {
      background-color: var(--va-white);
    }

    @media screen and (max-width: 640px) {
      margin-left: 0;
      margin-right: 0;

      &:first-of-type {
        margin-left: 0;
      }
    }
  }

  .fa-github {
    color: var(--va-on-background-primary);
  }
}
</style>
